/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * WifiIcon
 */
export default class WifiIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M16 15.3a1 1 0 11-1.2 1.6c-1.647-1.236-3.97-1.236-5.719.014a1 1 0 11-1.162-1.628c2.45-1.75 5.728-1.75 8.081.014zm3.738-3.47a1 1 0 01-1.276 1.54 10.02 10.02 0 00-12.824 0 1 1 0 01-1.276-1.54 12.02 12.02 0 0115.376 0zm3.518-3.585a1 1 0 11-1.312 1.51c-5.723-4.972-14.26-4.972-19.882-.006A1 1 0 11.738 8.251c6.377-5.634 16.04-5.634 22.518-.006zM12 22.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

